import { defineMessage } from 'react-intl';

export const promptCommonI18n = {
  selectDate: defineMessage({
    id: 'common:prompt.select-date',
    defaultMessage: 'Select a date'
  }),
  selectDates: defineMessage({
    id: 'common:prompt.select-dates',
    defaultMessage: 'Select dates'
  })
};
